import { styled } from '@linaria/react'
import {
  ButtonLoaderSizes,
  loaderStrokeMap,
  loaderBoxSizeMap,
} from './Button.h'

export const ButtonLoaderSC = styled.div<{
  loaderSize: ButtonLoaderSizes
  hasTitle: boolean
}>`
  width: ${({ loaderSize }) => loaderBoxSizeMap[loaderSize]}px;
  height: ${({ loaderSize }) => loaderBoxSizeMap[loaderSize]}px;
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: ${({ hasTitle }) => (hasTitle ? 8 : 0)}px;
  color: inherit;
  animation: spinner-rotate 1s linear infinite;

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }

  circle {
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-width: ${({ loaderSize }) => loaderStrokeMap[loaderSize]}px;
    stroke-dasharray: 75 25;
    stroke-dashoffset: 0;
  }

  @keyframes spinner-rotate {
    to {
      transform: rotate(360deg);
    }
  }
`
